import ReactDOM from "react-dom";

export default function Modal({
    isOpen,
    onClose,
    modalTitle,
    children,
    labelCloseBtn,
    labelSubmitBtn,
    size = "md",
    theme = "",
    zIndex = 1050 // مقدار پیش‌فرض z-index مدال
}) {

    const handleClose = () => {
        onClose(false);
    };

    return ReactDOM.createPortal(
        <>
            <div
                className={`modal fade ${isOpen ? "show" : ""}`}
                style={{
                    display: isOpen ? "block" : "none",
                    zIndex: zIndex // اعمال z-index به خود مدال
                }}
                id="modalTop"
                tabIndex="-1"
                aria-hidden={!isOpen}
                aria-modal={isOpen}
            >
                <div className={`modal-dialog modal-dialog-centered modal-${size}`} role="document">
                    <div className={`modal-content ${theme}`}>
                        <div className="modal-header">
                            <h5 className="modal-title secondary-font" id="modalCenterTitle">
                                {modalTitle ? modalTitle : ""}
                            </h5>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                        <div className="modal-footer">
                            {
                                labelCloseBtn ? (
                                    <button
                                        type="button"
                                        className="btn btn-label-secondary"
                                        onClick={handleClose}
                                        data-bs-dismiss="modal"
                                    >
                                        {labelCloseBtn}
                                    </button>
                                ) : null
                            }
                            {
                                labelSubmitBtn ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleClose}
                                    >
                                        {labelSubmitBtn}
                                    </button>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                isOpen && (
                    <div
                        className={`modal-backdrop fade ${isOpen ? "show" : ""}`}
                        style={{ zIndex: zIndex - 1 }} // z-index پس‌زمینه، یکی کمتر از مدال
                    ></div>
                )
            }
        </>,
        document.getElementById("root")
    );
}
